import { useEffect, useState } from "react";
import TasksTable from "../../Tables/DeltaHedgeMarketmaking/Tasks/TasksTable";
import { IMarketmakingTaskSearchParam } from "../../Interfaces/deltaHedgeMarketmaking";
import { DropdownItem } from "../../Interfaces/dropdownInterfaces";
import { packetErrorHandler } from "../../Utils/requestUtils";
import SelectableButtons from "../../Components/Dropdown/SelectableButtons";
import { getDistinctBaseInstrument } from "../../Requests/deltaHedgeMarketmaking";

const Tasks = () => {
  const [searchParam, setSearchParam] = useState(
    {} as IMarketmakingTaskSearchParam
  );
  const [baseInstruments, setBaseInstruments] = useState([] as DropdownItem[]);

  useEffect(() => {
    fetchInstruments();
  }, []);

  function fetchInstruments() {
    getDistinctBaseInstrument()
      .then((resp) => {
        setBaseInstruments(resp);
      })
      .catch(packetErrorHandler);
  }

  const changeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  return (
    <div className="w-full flex flex-col justify-start items-start gap-6 border border-gray-300 rounded p-3">
      <SelectableButtons
        label="نماد پایه"
        name="baseInsId"
        onChange={changeHandler}
        options={baseInstruments}
        value={searchParam.baseInsId}
      />
      <TasksTable
        searchParam={searchParam}
        refreshInstruments={fetchInstruments}
      />
    </div>
  );
};

export default Tasks;
